export default {"src":"/_next/static/media/curved-items-landing-4.fcacbd34.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};